import { NavigationMenuItem } from './nav-menu-item.model';
import { CHECK_PERMISSIONS } from '@shared/modules/permissions.module';

export const useNavigationMenu = () => {
  // Composable logic for navigation menu can be added here
  const validatePermission = CHECK_PERMISSIONS();
  const menuItems: NavigationMenuItem[] = [
    // Define your navigation menu items here
    {
        title:'Home', 
        icon:'home',
        route:'/home',
        validPermission: validatePermission.isAuthenticated()
    },
    {
        title:'Profile', 
        icon:'person',
        route:'/users/profile',
        validPermission: validatePermission.canReadProfile()
    },
    {
        title:'Users', 
        icon:'manage_accounts',
        route:'/user-management/users',
        validPermission: validatePermission.canManageUsers()
    },
    {
        title:'Employees', 
        icon:'groups',
        route:'/employees',
        validPermission: validatePermission.canReadEmployees()
    },
    {
        title:'Clients', 
        icon:'business',
        route:'/clients',
        validPermission: validatePermission.canReadClients()
    },
    {
        title:'Affiliates',
        icon:'medical_services',
        route:'/affiliates',
        validPermission: validatePermission.canReadAffiliates()
    },
    {
        title:'Interventions',
        icon:'health_and_safety',
        route:'/interventions',
        validPermission: validatePermission.canReadInterventions()
    },
    // {
    //     title:'Test Submenu Example',
    //     icon:'menu',
    //     validPermission: true,
    //     children: [
    //         {
    //             title:'Submenu Item 1',
    //             icon:'subdirectory_arrow_right',
    //             validPermission: true,
    //             children: [
    //                 {
    //                     title:'Submenu Item 1',
    //                     icon:'subdirectory_arrow_right',
    //                     validPermission: true,
    //                     route:'/home',
    //                     children: [
    //                         {
    //                             title:'Submenu Item 1',
    //                             icon:'subdirectory_arrow_right',
    //                             validPermission: true,
    //                             route:'/home',
    //                         },
    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             title:'Submenu Item 2',
    //             icon:'subdirectory_arrow_right',
    //             validPermission: true,
    //             route:'/home',
    //         }
    //     ]
    // }
  ];
  return{
    menuItems,
  }
};